import { request, Timeout } from '../../utils/http'

class SaleEndDate {
  constructor() {
    this._endDate = null
    this._observers = new Set()
    window.$saleEndDate = this

    this.fetchSaleEndDate()

    return this
  }

  get endDate() {
    return this._endDate
  }

  set endDate(endDate) {
    this._endDate = endDate
    this._notify(endDate)
  }

  subscribe(callback) {
    this.addObserver(callback)
  }

  setToStorage(time) {
    try {
      // eslint-disable-next-line
      typeof sessionStorage !== 'undefined' && sessionStorage.setItem(`saleEndDate:${landingInfo.landing_ID}`, time)
    } catch (e) {
      window.Sentry?.captureException(e)
    }
  }

  getFromStorage() {
    try {
      // eslint-disable-next-line
      return typeof sessionStorage !== 'undefined' && sessionStorage.getItem(`saleEndDate:${landingInfo.landing_ID}`)
    } catch (e) {
      window.Sentry?.captureException(e)
      return null
    }
  }

  async fetchSaleEndDate() {
    const saleEndTime = this.getFromStorage()

    if (saleEndTime && (new Date(saleEndTime) - new Date()) > 0) {
      this.endDate = saleEndTime

      return
    }

    try {
      // eslint-disable-next-line
      const response = await request(`/landgen/api/v1/landing/${landingInfo.landing_ID}/sale-end-date/`, { timeout: Timeout.REFERENCE })

      if (!response.ok) {
        await Promise.reject(response)
      }

      const { data } = await response.json()
      const time = data.sale_end_date.replace(/-/g, '/')

      if (Number.isNaN(new Date(time).getTime())) {
        throw new Error('Invalid sale end date')
      }

      this.endDate = time
      this.setToStorage(time)
    } catch (e) {
      e.message = `[SaleEndDate] ${e.message}`
      window.Sentry?.captureException(e)
    }
  }

  addObserver(observer) {
    if (this.endDate) {
      observer(this.endDate)
      return
    }

    this._observers.add(observer)
  }

  removeObserver(observer) {
    this._observers.delete(observer)
  }

  _notify(payload) {
    this._observers.forEach((observer) => observer(payload))
  }
}

export const saleEndDate = typeof window.$saleEndDate === 'object'
  ? window.$saleEndDate
  : new SaleEndDate()
